// src/scanresult/ScoreCalculation.js
import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

export default function ScoreCalculation({ state }) {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>Score calculation</Typography>
      <Typography paragraph>
        When you initiate a scan, the Barracuda Website Vulnerability Scanner automatically runs a comprehensive set of vulnerability checks against your application. These checks are designed to detect common security weaknesses and misconfigurations by comparing your website's setup against industry best practices and standards.
        <br />   Each check is scored individually, and your application receives a numerical score based on the results. A higher score indicates stronger security and better alignment with recommended security actions.
      </Typography>

      <Typography variant="h6" gutterBottom>Understanding your score</Typography>
      <Box component="ul" sx={{ pl: 3, mb: 2 }}>
        <li><Typography>Passed checks contribute their full score.</Typography></li>
        <li><Typography>Failed checks contribute zero.</Typography></li>
        <li><Typography>The total score reflects the sum of all passed checks.</Typography></li>
        <li><Typography>Security posture score = Total score / Sum of maximum possible scores for all checks</Typography></li>
      </Box>

      <Typography variant="h6" gutterBottom>Example scan result calculation</Typography>
      <Typography paragraph>
        Let's say the scanner runs 5 checks, each assigned a maximum score based on its potential impact on your website's security
      </Typography>

      <Typography paragraph color="text.secondary">
        Check 1 maximum score = 9 &nbsp;&nbsp; Check 2 maximum score = 8 &nbsp;&nbsp; Check 3 maximum score = 8 &nbsp;&nbsp; Check 4 maximum score = 7 &nbsp;&nbsp; Check 5 maximum score = 6
      </Typography>

      <TableContainer
        sx={{
          mb: 2,

          // prevents full width stretch
        }}
      >
        <Table size="small" style={{
          width: "50%",
          marginRight: "auto",

        }}>
          <TableHead>
            <TableRow>
              <TableCell><strong>Check</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell><strong>Score</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Check 1</TableCell>
              <TableCell>Passed</TableCell>
              <TableCell>9</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Check 2</TableCell>
              <TableCell>Failed</TableCell>
              <TableCell>0</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Check 3</TableCell>
              <TableCell>Passed</TableCell>
              <TableCell>8</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Check 4</TableCell>
              <TableCell>Passed</TableCell>
              <TableCell>7</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Check 5</TableCell>
              <TableCell>Failed</TableCell>
              <TableCell>0</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>


      <Typography paragraph>
        Total score = 9 + 0 + 8 + 7 + 0 = 24
        <br />Maximum possible score = 9 + 8 + 8 + 7 + 6 = 38
        <br />Security posture score = (24 / 38) x 100 = 63%
      </Typography>
    </Box>
  )
}

